import React, { FC } from 'react';
import alert_triangle from '../../assets/images/icons/alert-triangle.svg';

interface FieldErrorProps {
	id: string;
	message?: string;
}

export const FieldError: FC<FieldErrorProps> = ({ id, message }) => {
	return (
		<div id={id} role="alert" className="a11y-error-text">
			{message && (
				<>
					<img src={alert_triangle} alt="" aria-hidden="true" className="a11y-error-icon" />
					<span>{message}</span>
				</>
			)}
		</div>
	);
};

export default FieldError;
